export default __webpack_public_path__ + "static/media/button-do-example-2.65c4ad0d.svg";